'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TutorialOverlay(_ref) {
  var to = _ref.to,
      label = _ref.label,
      toggleTutorial = _ref.toggleTutorial;

  return _react2.default.createElement(
    _reactRouter.Link,
    { to: to, onClick: toggleTutorial },
    label
  );
}

exports.default = (0, _reactRedux.connect)(null, _selectors.mapDispatchToProps)(TutorialOverlay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Tutorial/TutorialButton.jsx
// module id = 1135
// module chunks = 0